import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { GridDataResult, PageChangeEvent, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { State, process, orderBy } from "@progress/kendo-data-query";
import { IFinishCategory, IPlaceOrderBody, ISampleFinish, ISampleRequest, IState, IUser } from '../../../core/models';
import { MasterDataService } from '../../../core/services/master-data.service';
import { SelfUtilityService } from '../../../core/services/self-utility.service';
import { UserService } from '../../../core/services/user.service';
import { PanelBarComponent, PanelBarExpandMode } from '@progress/kendo-angular-layout';
import { AppNotifyService } from '../../../core/services/app-notify.service';
import { NotifyType } from '../../../core/enums/NotifyType';

@Component({
  selector: 'app-sample-request',
  templateUrl: './sample-request.component.html',
  styleUrls: ['./sample-request.component.scss']
})
export class SampleRequestComponent implements OnInit {
 //#region Member Variables
  @ViewChild('panelbar', { static: false }) panel;
  public expandMode: number = PanelBarExpandMode.Multiple;
  public kendoPanelBarExpandMode: any = PanelBarExpandMode;
 
  sampleRequestForm: FormGroup;
  shippingDetailsForm: FormGroup;
  sampleRequestGridView: GridDataResult;
  public sampleRequestGridData: ISampleRequest[] = [];
  getFinishCategory: IFinishCategory[] = [];
  getFinish: ISampleFinish[] = [];
  getState: IState[] = [];
  sampleRequestLoading: boolean;
  maxQuantity: number;
  confirmDialogOpened: boolean;
  saveInProcess: boolean;
 //#endregion

 //#region constructor ngOnInit
  constructor(private formBuilder: FormBuilder, private selfService: SelfUtilityService, private userService: UserService, private masterDataService: MasterDataService, private appNotifyService: AppNotifyService) {
  }
  public get readUserObject(): IUser {
    return JSON.parse(localStorage.getItem('kdLogin')) as IUser;
  }
  ngOnInit(): void {
    this.sampleRequestForm = this.formBuilder.group({
      finishCategory: new FormControl(),
      finish: new FormControl(),
      quantity: new FormControl()
    })
    this.shippingDetailsForm = this.formBuilder.group({
      companyName: new FormControl(),
      jobName: new FormControl(),
      addressLine1: new FormControl(),
      addressLine2: new FormControl(),
      phoneNumber: new FormControl(),
      city: new FormControl(),
      state: new FormControl(),
      zipCode: new FormControl(),
    })
    this.selfService.getFinishCategories().subscribe((finishCategories) => {
      console.log(finishCategories)
      this.getFinishCategory = finishCategories as IFinishCategory[];
    });

    this.masterDataService.GetStates().subscribe(response => {
      console.log(response);
      this.getState = response;
      this.setValueInShippingForm();

    });
  }
 //#endregion

  //#region label/variable declaration
  sampleRequestLabel = {
    finishCategory: "Finish Catyegory",
    finish: "Finish",
    quantity: "Quantity"
  }
  sampleItems = {
    isEmptyFinishCategory: false,
    isEmptyFinish: false,
    isEmptyQuantity: false,
    isSubmitted: false,
    isSampleSelectionPanelValid: false,
    isContinueClicked:false
  }
  selectedState:string=""
  //#endregion
  //#region validation for sample request items
  protected validateSampleRequestForm(): boolean {
    let isValid = true;
    const controls = this.sampleRequestForm.controls;
    if (this.sampleItems.isSubmitted) {
      if (controls.finishCategory.value) {
        this.sampleItems.isEmptyFinishCategory = false;
      } else {
        this.sampleItems.isEmptyFinishCategory = true;
        isValid = false;
      }
      if (controls.finish.value) {
        if (controls.finish.value.finish) {
          this.sampleItems.isEmptyFinish = false;
        } else {
          this.sampleItems.isEmptyFinish = true;
          isValid = false;
        }
      } else {
        this.sampleItems.isEmptyFinish = true;
        isValid = false;
      }
      if (controls.quantity.value>0) {
        this.sampleItems.isEmptyQuantity = false;
      } else {
        this.sampleItems.isEmptyQuantity = true;
        isValid = false;
      }
      
    }
    return isValid;
  }
  //#endregion
  //#region sorting,filtering,pagination of grid
  loadSampleRequestGrid() {
    this.sampleRequestGridView = process(this.sampleRequestGridData, this.sampleRequestGridstate);
  }
  protected sampleRequestGridstate: State = {
    sort: [],
    skip: 0,
    take: 10,
    group: [],
    filter: null,
  };
  protected sampleRequestGridSortChange(sort): void {
    this.sampleRequestGridstate.sort = sort;
    this.loadSampleRequestGrid();
  }
  protected sampleRequestGridPageChange({ skip, take }: PageChangeEvent): void {
    this.sampleRequestGridstate.skip = skip;
    this.sampleRequestGridstate.take = take;
    this.loadSampleRequestGrid();

  }
  protected sampleRequestDataStateChange(state: DataStateChangeEvent): void {
    this.sampleRequestGridstate = state;
    this.loadSampleRequestGrid();
  }

  //#endregion
  //#region dropdown change
  categoryChange(event) {
    if (event.finishSampleLevel1key) {
      this.selfService.getSampleFinishes(event.finishSampleLevel1key).subscribe((sampleFinishes) => {
        console.log(sampleFinishes)
        this.getFinish = sampleFinishes as ISampleFinish[];
      });
      this.sampleRequestForm.controls.finish.value ? this.sampleRequestForm.controls.finish.value.finish="" : "";
      this.getFinish = [];
    }
  }
  finishChange(event) {
    this.maxQuantity = 1;
    if (event.finishSampleLevel1key) {       
        this.maxQuantity = event.maxQty;
    }
  }
  //#endregion
  //#region delete sample request row
  deleteSample(rowIndex) {
    this.sampleRequestGridData.splice(rowIndex,1);
    this.loadSampleRequestGrid();
  }
  //#endregion
  //#region add sample functionality
  addSelection() {
    this.sampleItems.isSubmitted = true;
    if (!this.validateSampleRequestForm()) {
      return;
    }
    const controls = this.sampleRequestForm.controls;
    const body = {
      category: controls.finishCategory.value?controls.finishCategory.value.category:"",
      finish: controls.finish.value ? controls.finish.value.finish : "",
      quantity: controls.quantity.value
    }
   // this.sampleRequestGridData.push(body);
    this.loadSampleRequestGrid();
    this.sampleRequestForm.reset();
    this.sampleItems.isSubmitted = false;
  }
  clearSelection() {
    this.sampleRequestForm.reset();
    this.sampleItems.isSubmitted = false;

  }
  //#endregion

  //#region shipping address panel operations
  continueToAddressPanel() {
    this.sampleItems.isContinueClicked = true;
    if (this.sampleRequestGridData.length > 0) {
      this.sampleItems.isSampleSelectionPanelValid = true;
      this.panel.childrenItems.forEach(item => {
        if (item.expanded) {
          item.expanded = false;
          item.selected = false;
        }
      });
      this.panel.childrenItems[1].expanded = true;
      this.panel.childrenItems[1].selected = true;
    } else {
      this.sampleItems.isSampleSelectionPanelValid = false;
    }
    this.sampleRequestForm.reset();
    this.sampleItems.isEmptyFinishCategory = false;
    this.sampleItems.isEmptyFinish = false;
    this.sampleItems.isEmptyQuantity = false;
    this.sampleItems.isSubmitted = false;

  }

  //#region label and variable declaration
  shippingDetails = {
    companyName: "Company Name",
    addressLine1: "Address Line 1",
    jobName: "Job Name",
    addressLine2: "Address Line 2",
    phoneNumber: "Phone Number",
    city: "City",
    state: "State",
    zipCode: "Zip Code",
    isEmptyCompanyName: false,
    isEmptyJobName: false,
    isEmptyAddress1: false,
    isEmptyPhoneNumber: false,
    isInvalidPhoneNumber: false,
    isEmptyCity: false,
    isEmptyState: false,
    isEmptyZipCode: false,
    isSubmitted: false,
    isShippingDetailsPanelValid: false,
    info1: "Orders received by the fulfillment company before 2:00 p.m. EST will ship the same day via FedEx Ground",
    info2:"Do not order Color Samples for Stock. Contact your Kawneer representative"
  }
  //#endregion
  //#region place order button operation
  protected validateShippingDetailsForm(): boolean {
    let isValid = true;
    const controls = this.shippingDetailsForm.controls;
    if (this.shippingDetails.isSubmitted) {
      if (controls.companyName.value) {
        this.shippingDetails.isEmptyCompanyName = false;
      } else {
        this.shippingDetails.isEmptyCompanyName = true;
        isValid = false;
      }
      if (controls.jobName.value) {
        this.shippingDetails.isEmptyJobName = false;
      } else {
        this.shippingDetails.isEmptyJobName = true;
        isValid = false;
      }
      if (controls.addressLine1.value) {
        this.shippingDetails.isEmptyAddress1 = false;
      } else {
        this.shippingDetails.isEmptyAddress1 = true;
        isValid = false;
      }
      if (controls.phoneNumber.value) {
        this.shippingDetails.isEmptyPhoneNumber = false;
        if ((controls.phoneNumber.value as string).toString().length !== 10) {
          this.shippingDetails.isInvalidPhoneNumber = true;
          isValid = false;
        } else {
          this.shippingDetails.isInvalidPhoneNumber = false;
        }
      } else {
        this.shippingDetails.isEmptyPhoneNumber = true;
        isValid = false;
      }
      if (controls.city.value) {
        this.shippingDetails.isEmptyCity = false;
      } else {
        this.shippingDetails.isEmptyCity = true;
        isValid = false;
      }
      if (controls.state.value) {
        this.shippingDetails.isEmptyState = false;
      } else {
        this.shippingDetails.isEmptyState = true;
        isValid = false;
      }
      if (controls.zipCode.value) {
        this.shippingDetails.isEmptyZipCode = false;
      } else {
        this.shippingDetails.isEmptyZipCode = true;
        isValid = false;
      }
    }
    return isValid;
  }
  placeOrder() {
    this.shippingDetails.isSubmitted = true;
    if (!this.validateShippingDetailsForm()) {
      this.shippingDetails.isShippingDetailsPanelValid = false;
      return;
    }
    if (this.sampleRequestGridData.length > 0) {
      this.sampleItems.isSampleSelectionPanelValid = true;
      this.shippingDetails.isShippingDetailsPanelValid = true;
      this.saveInProcess = true;
      const controls = this.shippingDetailsForm.controls;
      const body: IPlaceOrderBody = {
        sampleRequestItems: this.sampleRequestGridData,
        companyName: controls.companyName.value,
        jobName: controls.jobName.value,
        addressLine1: controls.addressLine1.value,
        addressLine2: controls.addressLine2.value,
        phoneNumber: controls.phoneNumber.value.toString(),
        city: controls.city.value,
        state: controls.state.value ? controls.state.value.stateDescription : "",
        zipCode: controls.zipCode.value,
        customerNumber: this.readUserObject.customerNumber,
        languageCode:"",
        //userId: this.readUserObject.userId
        stateCode: controls.state.value ? controls.state.value.stateCode : "",
        contactFirstName: controls.contact.value,
        contactLastName: controls.contact.value,
      }
      this.selfService.placeSampleRequest(body).subscribe(response => {
        this.confirmDialogOpened = true;
        this.setValueInShippingForm();
        this.sampleRequestGridData = [];
        this.loadSampleRequestGrid();
        this.shippingDetails.isSubmitted = false;
        this.sampleItems.isContinueClicked = false;
        this.saveInProcess = false;
      })
    }
    else {
      this.shippingDetails.isShippingDetailsPanelValid = true;
      this.sampleItems.isSampleSelectionPanelValid = false;
      this.sampleItems.isContinueClicked = true;

    }
  }
  //sets value in controls from localstorage
  setValueInShippingForm() {
    const data = this.userService.readUserObject;
    this.shippingDetailsForm.controls.companyName.setValue(data.customerName),
      this.shippingDetailsForm.controls.jobName.setValue(""),
      this.shippingDetailsForm.controls.addressLine1.setValue(data.addressLine1),
      this.shippingDetailsForm.controls.addressLine2.setValue(""),
      this.shippingDetailsForm.controls.phoneNumber.setValue(""),
      this.shippingDetailsForm.controls.city.setValue(data.city),
      //this.shippingDetailsForm.controls.state.setValue(data.state),
      this.shippingDetailsForm.controls.zipCode.setValue(data.zipCode)
      this.selectedState=data.state;
  }
  
  //#endregion
  //#endregion
  confirmDialogClose() {
    this.confirmDialogOpened = false;
  }
}
